import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseCreateResource } from '../../utils/types';

type FlightSegmentInput = TrpcInputs['createFlightSegmentForQuote'];
type FlightSegmentOutput = TrpcOutputs['createFlightSegmentForQuote'];

type CreateFlightSegmentMutate = MutateFunction<FlightSegmentInput, FlightSegmentOutput>;
type UseCreateFlightSegment = UseCreateResource<FlightSegmentInput, FlightSegmentOutput>;

export const useCreateFlightSegment = (quoteId?: number): UseCreateFlightSegment => {
  const { mutateAsync: createAsync, isLoading, error } = trpc.createFlightSegmentForQuote.useMutation();

  const create: CreateFlightSegmentMutate = (args) => createAsync({ quote_id: quoteId, ...args } as FlightSegmentInput);

  return {
    create,
    isLoading,
    error: error?.message,
  };
};
